import React, { useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";

function ArticleContent() {
    const [expanded, setExpanded] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const faqItems = [
        {
            q: "Ce include curățenia profesională într-o clinică?",
            a: "Depinde de evaluarea spațiului și de contract. În mod obișnuit intră recepția, sala de așteptare, holurile, grupurile sanitare, pardoselile, suprafețele accesibile și mobilierul din zonele generale. Lista exactă se stabilește înainte de începerea colaborării.",
        },
        {
            q: "Cât costă curățenia pentru o clinică sau un cabinet medical?",
            a: "Nu există un preț unic, pentru că tariful depinde de suprafață, de zonele incluse, de frecvență și de intervalul în care se lucrează. Venim la fața locului, vedem spațiul și revenim cu o ofertă fermă, fără costuri ascunse.",
        },
        {
            q: "Firma de curățenie se ocupă de toate zonele unei clinici?",
            a: "Nu neapărat. Responsabilitățile se delimitează în funcție de tipul clinicii, de zonele accesibile, de procedurile interne și de serviciile contractate. Unele zone și operațiuni rămân, prin natura lor, în sarcina personalului medical.",
        },
        {
            q: "Curățarea și dezinfecția sunt același lucru?",
            a: "Nu. Curățarea îndepărtează murdăria și impuritățile, iar dezinfecția este o operațiune distinctă, realizată cu produse și metode adecvate suprafeței și scopului. Normele tehnice din domeniul sanitar le tratează separat.",
        },
        {
            q: "Doral Cleaning sterilizează instrumentarul medical?",
            a: "Nu. Sterilizarea instrumentarului este un proces distinct de curățenia generală a spațiului și rămâne în responsabilitatea clinicii, conform propriilor proceduri.",
        },
        {
            q: "Curățenia poate fi realizată după programul clinicii?",
            a: "Da. Intervențiile pot fi programate înainte de deschidere, după încheierea programului sau în alte intervale convenite, în limitele serviciului contractat și ale accesului disponibil.",
        },
        {
            q: "Cât de des trebuie făcută curățenia într-o clinică?",
            a: "Nu există o frecvență universală. Ritmul se stabilește în funcție de tipul spațiului, de utilizarea fiecărei zone, de cerințele aplicabile clinicii și de responsabilitățile acoperite intern.",
        },
        {
            q: "În ce zone lucrați?",
            a: "Acoperim întreg municipiul București și localitățile limitrofe din Ilfov. Pentru locațiile mai îndepărtate stabilim condițiile de deplasare la momentul evaluării.",
        },
    ];

    return (
        <MKBox component="section" py={4} mb={8}>
            <Container>
                <Grid container item xs={12} lg={10} mx="auto" direction="column">
                    <MKTypography variant="h2" mb={3} color="dark">
                        Curățenie pentru clinici și cabinete medicale
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={2}>
                        Un cabinet medical nu se întreține după aceleași reguli ca un birou sau un spațiu comercial. Ai un flux constant de pacienți, zone cu destinații complet diferite sub același acoperiș, suprafețe atinse de zeci de ori pe zi și un program medical cu care intervenția trebuie să se sincronizeze. De aceea, un serviciu de curățenie pentru clinici se construiește pornind de la spațiul real, nu de la un pachet standard.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        La Doral Cleaning evaluăm locația, stabilim împreună zonele în care intervine echipa noastră și propunem un program clar de operațiuni și frecvențe. Lucrăm de peste 20 de ani cu spații comerciale, instituționale și industriale din București, iar în clinici aplicăm aceeași logică: responsabilități delimitate corect între prestator și personalul medical, fără zone lăsate la presupunere.
                    </MKTypography>

                    {/* Banner Evaluare Gratuită */}
                    <MKBox
                        sx={{
                            backgroundColor: "#e9f5f3",
                            borderLeft: "4px solid #0f766e",
                            p: 3,
                            borderRadius: "0 8px 8px 0",
                            mb: 4,
                        }}
                    >
                        <MKTypography variant="body1" color="dark" fontWeight="bold">
                            Solicită o evaluare gratuită:{" "}
                            <span style={{ fontWeight: "normal" }}>
                                Vedem spațiul, discutăm zonele incluse și primești o ofertă adaptată clinicii tale.
                            </span>
                        </MKTypography>
                        <MKBox mt={1.5} display="flex" gap={2} flexWrap="wrap" alignItems="center">
                            <MKButton
                                component={Link}
                                to="/contact-curatenie/"
                                variant="gradient"
                                color="info"
                                size="small"
                            >
                                Cere o ofertă pentru clinica ta
                            </MKButton>
                            <MKTypography variant="button" color="text" fontWeight="bold">
                                Telefon:{" "}
                                <a href="tel:0730407322" style={{ color: "#1a73e8", textDecoration: "none" }}>
                                    0730 407 322
                                </a>
                            </MKTypography>
                        </MKBox>
                    </MKBox>

                    {/* Imagine Principală */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/d08GpF5b/image-41.jpg"
                        alt="Servicii profesionale de curățenie pentru clinici și cabinete medicale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Cuprins */}
                    <MKBox
                        sx={{
                            backgroundColor: "#f7f9fc",
                            borderLeft: "4px solid #1a73e8",
                            p: 3,
                            borderRadius: "0 8px 8px 0",
                            mb: 4,
                        }}
                    >
                        <MKTypography variant="h6" color="dark" mb={1}>
                            Cuprins pagină:
                        </MKTypography>
                        <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0, lineHeight: 1.8 }}>
                            <li><a href="#de-ce-diferita" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>De ce curățenia unei clinici este diferită de curățenia unui birou</a></li>
                            <li><a href="#tipuri-spatii" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Ce tipuri de spații medicale acoperim</a></li>
                            <li><a href="#zone-incluse" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Ce zone poate include curățenia profesională într-o clinică</a></li>
                            <li><a href="#diferenta-curatare-dezinfectie" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Curățare, dezinfecție și sterilizare: care este diferența</a></li>
                            <li><a href="#delimitare-responsabilitati" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Delimitarea zonelor și a responsabilităților: cine ce curăță</a></li>
                            <li><a href="#stabilire-plan" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Cum stabilim planul de curățenie pentru o clinică</a></li>
                            <li><a href="#intretinere-vs-generala" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Curățenie de întreținere sau curățenie generală</a></li>
                            <li><a href="#fara-intrerupere" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Curățenie fără întreruperea programului cu pacienții</a></li>
                            <li><a href="#de-ce-externalizare" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>De ce să externalizezi curățenia zonelor generale</a></li>
                            <li><a href="#stabilire-oferta" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Cum se stabilește oferta pentru curățenia unei clinici</a></li>
                            <li><a href="#faq" style={{ color: "#1a73e8", textDecoration: "none", fontWeight: 600 }}>Întrebări frecvente despre curățenia clinicilor</a></li>
                        </ul>
                    </MKBox>

                    {/* Sectiune 1 */}
                    <MKTypography id="de-ce-diferita" variant="h3" mt={2} mb={2} color="dark">
                        De ce curățenia unei clinici este diferită de curățenia unui birou
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Într-un birou, traficul este previzibil și relativ uniform. Într-o clinică, lucrurile stau altfel: pacienți care intră și ies pe tot parcursul zilei, personal care se deplasează între zone cu destinații diferite, recepții și săli de așteptare folosite intens ore în șir. La acestea se adaugă suprafețele atinse frecvent – mânere, clanțe, balustrade, blaturi de recepție, scaune – și grupurile sanitare, care au nevoie de o organizare separată a operațiunilor.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Diferența nu ține doar de intensitate, ci de organizare. Materialele și ustensilele trebuie delimitate pe zone, iar ordinea intervențiilor contează la fel de mult ca produsele folosite – motiv pentru care codurile de culori folosite în curățenie sunt un instrument util în orice spațiu cu zone de risc diferit. În plus, echipa nu poate lucra oricând: intervenția se coordonează cu programul medical, astfel încât să nu se suprapună peste consultații.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Normele tehnice în vigoare cer unității sanitare un spațiu dedicat pentru depozitarea produselor și a ustensilelor de curățenie, cu pereți și pavimente impermeabile și ușor de curățat. Verificăm și acest aspect la evaluare, pentru că influențează direct felul în care organizăm intervenția. Concluzia practică: nu există un pachet standard potrivit tuturor clinicilor.
                    </MKTypography>

                    {/* Sectiune 2 */}
                    <MKTypography id="tipuri-spatii" variant="h3" mt={3} mb={2} color="dark">
                        Ce tipuri de spații medicale acoperim
                    </MKTypography>
                    <MKTypography variant="h5" color="dark" mt={1} mb={1}>
                        Clinici private și policlinici
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Recepții, săli de așteptare, holuri, spații administrative, grupuri sanitare și celelalte zone stabilite prin contract. Sunt locațiile în care volumul de trafic justifică un program recurent, cu operațiuni bine definite pentru fiecare zonă.
                    </MKTypography>

                    <MKTypography variant="h5" color="dark" mt={1} mb={1}>
                        Cabinete medicale individuale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Pentru cabinetele individuale sau de mici dimensiuni, intervenția se dimensionează după suprafață, specialitate și după linia clară dintre ce face echipa externă și ce rămâne în sarcina personalului medical.
                    </MKTypography>

                    <MKTypography variant="h5" color="dark" mt={1} mb={1}>
                        Cabinete stomatologice
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Aici separarea este esențială. Ne ocupăm de curățenia generală a spațiului, în zonele agreate, iar procedurile medicale specifice și tot ce ține de instrumentar rămân în responsabilitatea personalului clinicii, conform propriilor proceduri interne.
                    </MKTypography>

                    <MKTypography variant="h5" color="dark" mt={1} mb={1}>
                        Centre de recuperare și alte spații medicale
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Centrele de recuperare, laboratoarele de analize sau spațiile conexe pot fi incluse după o evaluare prealabilă, în funcție de zonele accesibile echipei și de operațiunile care pot fi preluate.
                    </MKTypography>

                    {/* Sectiune 3 */}
                    <MKTypography id="zone-incluse" variant="h3" mt={3} mb={2} color="dark">
                        Ce zone poate include curățenia profesională într-o clinică
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Lista descrie zonele obișnuite dintr-un plan de lucru. Ce intră efectiv în serviciu se stabilește la evaluare și se trece în contract:
                    </MKTypography>

                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• Recepția și sala de așteptare:</strong> Pardoseli, mobilier, scaune, blaturi, uși, mânere și celelalte suprafețe accesibile incluse în planul de lucru.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• Holuri și zone comune:</strong> Tranzitate intens pe tot parcursul zilei; frecvența și metoda se adaptează traficului real.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• Grupuri sanitare:</strong> Se organizează separat, cu ustensile și materiale dedicate (codificate coloristic), într-o succesiune menită să prevină contaminarea încrucișată.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• Cabinete și spații de consultație:</strong> Operațiuni generale agreate: pardoseli, suprafețe accesibile, mobilier neasociat actului medical, coșuri, uși. Echipamentele medicale și instrumentarul nu intră automat în serviciu.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• Pardoseli:</strong> Gresie, PVC, linoleum sau covor PVC medical. Pentru intervenții ample avem serviciul dedicat de <Link to="/curatare-pardoseli/" style={{ color: "#1a73e8" }}>curățare profesională a pardoselilor</Link> și aplicarea de <Link to="/intretinere-si-tratamente-aplicate-pentru-pardoseli/" style={{ color: "#1a73e8" }}>tratamente de protecție pentru pardoseli</Link>.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        <strong>• Geamuri și suprafețe vitrate:</strong> Ferestre, uși vitrate, pereți despărțitori de sticlă prin serviciul de <Link to="/curatare-geamuri-suprafete-vitrate/" style={{ color: "#1a73e8" }}>curățare a suprafețelor vitrate</Link>.
                    </MKTypography>

                    {/* Imagine Secundara 1 */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/Rky46m0B/image-43.jpg"
                        alt="Zonele unei clinici incluse în planul de curățenie"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Sectiune 4 */}
                    <MKTypography id="diferenta-curatare-dezinfectie" variant="h3" mt={3} mb={2} color="dark">
                        Curățare, dezinfecție și sterilizare: care este diferența
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Cele trei noțiuni sunt folosite frecvent ca sinonime în comunicarea comercială, deși descriu lucruri diferite. Distincția contează, mai ales într-o clinică:
                    </MKTypography>
                    <ul>
                        <li><strong>Curățarea:</strong> urmărește îndepărtarea murdăriei, a prafului și a impurităților de pe suprafețe. Este operațiunea de bază, iar fără ea celelalte nu își ating scopul.</li>
                        <li><strong>Dezinfecția:</strong> este o operațiune distinctă, realizată cu produse biocide avizate și cu metode potrivite scopului și tipului de suprafață.</li>
                        <li><strong>Sterilizarea:</strong> este un proces diferit, cu cerințe proprii (autoclav, căldură, proceduri chimice), și nu trebuie folosită ca formulă pentru „o curățenie foarte bună”.</li>
                    </ul>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Normele tehnice aprobate prin Ordinul ministrului sănătății nr. 1.761/2021 tratează separat aceste procese în unitățile sanitare publice și private și stabilesc inclusiv ce tipuri de produse biocide pot fi utilizate. Am detaliat aceste diferențe și în articolul dedicat <Link to="/blog/dezinfectie-vs-curatenie/" style={{ color: "#1a73e8" }}>Dezinfecție vs. Curățenie</Link>.
                    </MKTypography>

                    {/* Imagine Secundara 2 */}
                    <MKBox
                        component="img"
                        src="https://i.ibb.co/5XQBSZ8x/image-44.jpg"
                        alt="Diferența dintre curățare, dezinfecție și sterilizare în spațiile medicale"
                        width="100%"
                        borderRadius="xl"
                        shadow="md"
                        mb={4}
                    />

                    {/* Sectiune 5 */}
                    <MKTypography id="delimitare-responsabilitati" variant="h3" mt={3} mb={2} color="dark">
                        Delimitarea zonelor și a responsabilităților: cine ce curăță
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Cea mai frecventă sursă de neînțelegeri în colaborarea dintre o clinică și o firmă de curățenie nu este calitatea lucrului, ci presupunerea. Se presupune că echipa externă se ocupă de tot sau, invers, că personalul intern acoperă zonele rămase. Într-o clinică de specialitate, ambele presupuneri produc goluri.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        De aceea, planul de lucru precizează în scris: zonele în care intervine echipa Doral Cleaning, operațiunile incluse pentru fiecare zonă, zonele și procedurile care rămân în responsabilitatea personalului medical, suprafețele asupra cărora echipa externă nu intervine, precum și programul de execuție.
                    </MKTypography>

                    {/* Sectiune 6 */}
                    <MKTypography id="stabilire-plan" variant="h3" mt={3} mb={2} color="dark">
                        Cum stabilim planul de curățenie pentru o clinică
                    </MKTypography>
                    <ol style={{ paddingLeft: "1.25rem", lineHeight: 1.8, marginBottom: "2rem" }}>
                        <li><strong>Evaluarea inițială a spațiului:</strong> Suprafață, încăperi, pardoseli, trafic, program și particularități de acces.</li>
                        <li><strong>Delimitarea zonelor de intervenție:</strong> Stabilim împreună unde intervine echipa noastră și ce rămâne intern.</li>
                        <li><strong>Stabilirea operațiunilor:</strong> Definim ce se execută zilnic și ce operațiuni periodice sunt necesare.</li>
                        <li><strong>Stabilirea frecvenței:</strong> Adaptată utilizării reale a spațiului.</li>
                        <li><strong>Stabilirea programului:</strong> Fixăm intervalul optim de lucru pentru a nu perturba consultațiile.</li>
                        <li><strong>Verificarea serviciului:</strong> Monitorizare periodică a calității de către supervizori.</li>
                    </ol>

                    {/* Sectiune 7 */}
                    <MKTypography id="intretinere-vs-generala" variant="h3" mt={3} mb={2} color="dark">
                        Curățenie de întreținere sau curățenie generală
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Cele două servicii nu se exclud, ci se completează:
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={1}>
                        <strong>• <Link to="/curatenie-de-intretinere/" style={{ color: "#1a73e8" }}>Curățenia de întreținere</Link>:</strong> Operațiuni recurente menite să mențină spațiile de tranzit, recepția și toaletele impecabile zi de zi.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        <strong>• <Link to="/curatenie-generala/" style={{ color: "#1a73e8" }}>Curățenia generală</Link>:</strong> Intervenție minuțioasă periodică, incluzând zone greu accesibile, spălare geamuri și tratamente mecanizate pentru pardoseli.
                    </MKTypography>

                    {/* Sectiune 8 */}
                    <MKTypography id="fara-intrerupere" variant="h3" mt={3} mb={2} color="dark">
                        Curățenie fără întreruperea programului cu pacienții
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Intervențiile pot fi programate:
                    </MKTypography>
                    <ul>
                        <li>înainte de începerea programului, pentru ca spațiul să fie pregătit la prima oră;</li>
                        <li>după terminarea programului, când cabinetele sunt eliberate;</li>
                        <li>în weekend, prin pachetele de <Link to="/curatenie-in-weekend/" style={{ color: "#1a73e8" }}>curățenie în weekend</Link>, când se pot executa lucrări ample sau cu timpi de uscare.</li>
                    </ul>

                    {/* Sectiune 9 */}
                    <MKTypography id="de-ce-externalizare" variant="h3" mt={3} mb={2} color="dark">
                        De ce să externalizezi curățenia zonelor generale
                    </MKTypography>
                    <ul>
                        <li>Echipă dedicată, instruită pentru specificul unităților medicale;</li>
                        <li>Peste 20 de ani de activitate și mii de proiecte finalizate cu succes;</li>
                        <li>Asigurare profesională a bunurilor din locație;</li>
                        <li>Produse profesionale și eco-friendly, conforme standardelor europene;</li>
                        <li>Continuitate garantată: intervențiile nu depind de concedii sau fluctuația de personal;</li>
                        <li>Program flexibil și adaptabil;</li>
                        <li>Membru în Patronatul Industriei de Curățenie.</li>
                    </ul>

                    {/* Sectiune 10 */}
                    <MKTypography id="stabilire-oferta" variant="h3" mt={3} mb={2} color="dark">
                        Cum se stabilește oferta pentru curățenia unei clinici
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={2}>
                        Nu lucrăm cu un tarif fix generic pe metru pătrat, deoarece două clinici cu aceeași suprafață pot avea nevoi complet diferite. Oferta se construiește după vizionare și ține cont de suprafața totală, numărul de încăperi, zonele incluse, frecvență, program și operațiunile periodice solicitate.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3}>
                        Deplasarea pentru evaluare este gratuită în București și în localitățile din Ilfov. Sediul nostru este pe Calea Șerban Vodă nr. 82, Sector 4, așa că ajungem rapid în orice sector.
                    </MKTypography>

                    {/* FAQ */}
                    <MKTypography id="faq" variant="h3" mt={4} mb={3} color="dark">
                        Întrebări frecvente despre curățenia clinicilor
                    </MKTypography>
                    {faqItems.map((item, index) => (
                        <Accordion
                            key={index}
                            expanded={expanded === `panel${index}`}
                            onChange={handleAccordionChange(`panel${index}`)}
                            sx={{ mb: 1.5, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <MKTypography variant="h6" color="dark" fontWeight="bold">
                                    {item.q}
                                </MKTypography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <MKTypography variant="body2" color="text">
                                    {item.a}
                                </MKTypography>
                            </AccordionDetails>
                        </Accordion>
                    ))}

                    {/* Banner Final CTA */}
                    <MKBox
                        sx={{
                            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
                            borderRadius: "16px",
                            p: 4,
                            mt: 5,
                            textAlign: "center",
                            color: "#fff",
                        }}
                    >
                        <MKTypography variant="h4" color="white" mb={1}>
                            Curățenie profesională adaptată clinicii tale
                        </MKTypography>
                        <MKTypography variant="body1" color="white" opacity={0.9} mb={3}>
                            Evaluăm spațiul înainte de a propune serviciul și construim un plan adaptat suprafeței, zonelor incluse și programului medical.
                        </MKTypography>
                        <MKButton
                            component={Link}
                            to="/contact-curatenie/"
                            variant="gradient"
                            color="white"
                            size="large"
                            sx={{ color: "#1a73e8", fontWeight: 700 }}
                        >
                            Cere o ofertă pentru clinica ta
                        </MKButton>
                        <MKTypography variant="body2" color="white" mt={2}>
                            Sau sună-ne direct la:{" "}
                            <a href="tel:0730407322" style={{ color: "#fff", fontWeight: 700 }}>
                                0730 407 322
                            </a>
                        </MKTypography>
                    </MKBox>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
